/**
 * Converts a date string from various formats to API format (YYYYMMDD)
 * @param dateString - Date string in format like "2025-01-15" or "01/15/2025"
 * @returns Date string in format YYYYMMDD
 */
export const convertDateToAPIFormat = (dateString: string): string => {
  if (!dateString) {
    return "";
  }

  // If already in YYYYMMDD format
  if (/^\d{8}$/.test(dateString)) {
    return dateString;
  }

  // Try to parse the date
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}${month}${day}`;
};

/**
 * Converts a date string to MM/DD/YYYY format for CMM API
 * @param dateString - Date string in format like "2025-01-15" or "01/15/2025"
 * @returns Date string in format MM/DD/YYYY
 */
export const convertDateToMMDDYYYYFormat = (dateString: string): string => {
  if (!dateString) {
    return "";
  }

  // If already in MM/DD/YYYY format
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    return dateString;
  }

  // Try to parse the date
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${month}/${day}/${year}`;
};
